<template>
  <div class="metric-list">
    <MetricItem
      v-for="metric in list"
      :metricType="metricType"
      :key="metric.category_id"
      :metric="metric"
      @showDetails="showDetails"
    />
  </div>
</template>

<script>
import MetricItem from './MetricItem.vue'

const props = {
  list: {
    require: true,
    type: Array,
  },
  metricType: {
    require: false,
    type: String,
    default: 'list',
  },
}

export default {
  components: { MetricItem },
  props: props,
  methods: {
    showDetails() {
      this.$emit('showDetails')
    },
  },
}
</script>

<style lang="scss" scoped>
.metric-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
</style>
